import { defineMessages, FormattedMessage } from "react-intl";

import { InputField } from "@ps-design-system/components/Input";
import { Text } from "@ps-design-system/components/Text";
import LightbulbIcon from "@ps-design-system/icons/Lightbulb/Lightbulb32";

import { useIntl } from "react-intl-compat";

const LIST_ITEMS = defineMessages({
  locationHelper: {
    id: "hosting.space_details.title_helper",
    defaultMessage: "Location",
  },
  locationExample: {
    id: "hosting.space_details.title_helper_example",
    defaultMessage: "urban, downtown, marina",
  },
  typeHelper: {
    id: "hosting.space_details.title_helper2",
    defaultMessage: "The type of space",
  },
  typeExample: {
    id: "hosting.space_details.title_helper_example2",
    defaultMessage: "loft, studio, dance hall, penthouse",
  },
  adjectiveHelper: {
    id: "hosting.space_details.title_helper3",
    defaultMessage: "Unique adjective",
  },
  adjectiveExample: {
    id: "hosting.space_details.title_helper_example3",
    defaultMessage: "industrial, rustic, roomy",
  },
});

const SpaceTitleField = () => {
  const intl = useIntl();

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.title_header"
            defaultMessage="Give your space a title"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.title_text"
            defaultMessage="Create a title that will grab a guest's interest and describes your space. Do not include your business's name."
          />
        </Text>
      </div>

      <div>
        <Text typeface="body-2-m">
          <FormattedMessage
            id="hosting.space_details.title_example_header"
            defaultMessage="Try to include the following:"
          />
        </Text>
        <ul className="tw-list-disc tw-list-inside tw-m-0">
          <Text element="li">
            <Text typeface="body-2-m">
              <FormattedMessage {...LIST_ITEMS.locationHelper} />
            </Text>
            {" - "}
            <Text typeface="body-2">
              <FormattedMessage {...LIST_ITEMS.locationExample} />
            </Text>
          </Text>
          <Text element="li">
            <Text typeface="body-2-m">
              <FormattedMessage {...LIST_ITEMS.typeHelper} />
            </Text>
            {" - "}
            <Text typeface="body-2">
              <FormattedMessage {...LIST_ITEMS.typeExample} />
            </Text>
          </Text>
          <Text element="li">
            <Text typeface="body-2-m">
              <FormattedMessage {...LIST_ITEMS.adjectiveHelper} />
            </Text>
            {" - "}
            <Text typeface="body-2">
              <FormattedMessage {...LIST_ITEMS.adjectiveExample} />
            </Text>
          </Text>
        </ul>
      </div>

      <Text
        element="p"
        prefix={
          <LightbulbIcon className="tw-flex-shrink-0 tw-text-yellow-600" />
        }
        className="tw-m-0"
      >
        <FormattedMessage
          id="hosting.space_details.title_example"
          defaultMessage='Example: "Downtown Loft with Skyline View"'
        />
      </Text>

      <InputField
        fullWidth
        name="title"
        placeholder={intl.formatMessage({
          id: "hosting.space_details.enter_space_title",
          defaultMessage: "Enter your space title",
        })}
        required
        testId="space-details-form-title-input"
      />
    </div>
  );
};

export { SpaceTitleField };
